import React, { useState, useEffect } from 'react';
import {
  Direction,
  Margin,
  Text,
  TextSmall,
  IconSavings,
  IconInvestment,
  Column,
  TextCaption
} from '@scotia/canvas-react';
import PropTypes from 'prop-types';
import { DataPair } from '@cldf/scotiaweb-canvas-react';
import styles from '../Account/AccountContent.scss';
import { ThreeColumnProductsLayout } from '../ThreeColumnProductsLayout';
import { DataProducts } from '../DataProducts';
import { DataBalance } from '../DataBalance';
import { numberFormatter as nf } from '../../Amounts.Converter';
import { SummaryContextMenu } from '../SummaryContextMenu';
import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { MercuryGroup, MercuryZone } from "mercury-react-sdk";
import { getMercurySettings } from '../../../../../services/service.parameters';

const numberFormatter = (value, currency) =>
  currency === 'CLP' ? `$${nf(value)}` : `${currency}  ${nf(value)}`;

const preparedArray = props => {
  let array = [];
  if (props.list.term_deposits !== undefined) {
    array = props.list.term_deposits.concat(props.list.mutual_funds);
  } else {
    array = props.list.mutual_funds;
  }
  return array.filter(arr => arr !== undefined);
};
const InvestmentContent = props => {

  const [mercuryApiUrl, setMercuryApi] = useState(undefined);
  const [mercuryRenderersUrl, setMercuryRenderersUrl] = useState(undefined);
  const [mercuryEnabled, setMercuryEnabled] = useState(undefined);

  const getSession = async () => {
    const session = await getAllInSession();
    const { mercuryApiUrl, mercuryRenderersUrl } = await getMercurySettings();
    console.log("mercuryApiUrl", mercuryApiUrl, "mercuryRendersUrls", mercuryRenderersUrl);
    setMercuryEnabled(session.TGLMER !== undefined);
    setMercuryApi(mercuryApiUrl);
    setMercuryRenderersUrl(mercuryRenderersUrl);
  };

  useEffect(() => {
      getSession();
  }, []);

  return(
    <Direction className={styles['account-content-container']}>
      {props.list !== null && (
        <div style={{ width: '100%' }}>
          {preparedArray(props).map((investmentObject, i) => (
            <>
              <RendererInvestmentContent investment={investmentObject} />
              { i == 0 && mercuryApiUrl && mercuryRenderersUrl &&
                <Margin side={'top'} xs={24} sm={24} md={24} lg={24}>
                  <MercuryGroup
                    apiUrl={mercuryApiUrl}
                    tokenUrl={
                      "/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends="
                    }
                    renderersUrl={mercuryRenderersUrl}
                    id="invest_section_sweb"
                    withEventstream={false}
                    tokenExpireTime={40000}
                    interactionEnabled={mercuryEnabled}
                    onError={(error) => console.log("Error al cargar mercury", error)}
                  >
                    <MercuryZone id="invest_section_sweb_1" />
                  </MercuryGroup>
                </Margin>
              }
            </>
          ))}
        </div>
      )}
    </Direction>
  )
};

const isTermDeposit = productType => productType === 'term_deposit';

const RendererInvestmentContent = props => (
  <Direction className={styles['account-content-container']}>
    <Margin
      md={24}
      xs={6}
      sm={12}
      lg={24}
      side={'top'}
      className={styles['account-content-card-info']}
    >
      <ThreeColumnProductsLayout
        renderCol1={() => (
          <div style={{ padding: 0 }}>
            {/* <div className="hide--lg hide--md"> */}
            <Direction type="row" className="hide--lg hide--md">
              <Column xs={6} sm={6}>
                <TextSmall className="text--roman">
                  {props.investment.product_information.product_name}
                </TextSmall>
                {!isTermDeposit(
                  props.investment.product_information.product_type
                ) && (
                  <TextSmall className="text--roman">
                    {props.investment.product_information.display_id}
                  </TextSmall>
                )}
                <DataPair
                  title={
                    <TextCaption className="text--light">
                      {isTermDeposit(
                        props.investment.product_information.product_type
                      )
                        ? 'Monto invertido'
                        : 'Saldo a la fecha'}
                    </TextCaption>
                  }
                  text={
                    <TextSmall style={{ color: '#333', fontWeight: 'bold' }}>
                      {isTermDeposit(
                        props.investment.product_information.product_type
                      )
                        ? numberFormatter(
                            props.investment.saved_balance.amount,
                            props.investment.saved_balance.currency_code
                          )
                        : numberFormatter(
                            props.investment.available_balance.amount,
                            props.investment.available_balance.currency_code
                          )}
                    </TextSmall>
                  }
                />
                {isTermDeposit(
                  props.investment.product_information.product_type
                ) && (
                  <DataPair
                    title={
                      <TextCaption className="text--light">
                        Monto a Retirar
                      </TextCaption>
                    }
                    text={
                      <TextSmall style={{ color: '#333', fontWeight: 'bold' }}>
                        {numberFormatter(
                          props.investment.available_balance.amount,
                          props.investment.available_balance.currency_code
                        )}
                      </TextSmall>
                    }
                  />
                )}
              </Column>
              {isTermDeposit(
                props.investment.product_information.product_type
              ) ? (
                <React.Fragment>
                  <Column xs={5} sm={5}>
                    <TextCaption className="text--light">
                      {' '}
                      Plazo {props.investment.term} días
                    </TextCaption>
                    <DataPair
                      title={
                        <TextCaption className="text--light">
                          {' '}
                          Vence
                        </TextCaption>
                      }
                      text={
                        <TextCaption>{props.investment.end_date}</TextCaption>
                      }
                    />
                  </Column>
                  <Column xs={1} sm={1}>
                    <div
                      style={{
                        display: 'flex',
                        marginRight: '-20px',
                        marginTop: '-3px',
                        paddingLeft: '4px',
                        float: 'right'
                      }}
                    >
                      <SummaryContextMenu
                        productType={
                          props.investment.product_information.product_type
                        }
                        account={
                          props.investment.product_information.display_id
                        }
                        productName={
                          props.investment.product_information.product_name
                        }
                      />
                    </div>
                  </Column>
                </React.Fragment>
              ) : (
                <Column xs={6} sm={6}>
                  <div
                    style={{
                      display: 'flex',
                      marginRight: '-20px',
                      marginTop: '-3px',
                      paddingLeft: '4px',
                      float: 'right'
                    }}
                  >
                    <SummaryContextMenu
                      productType={
                        props.investment.product_information.product_type
                      }
                      account={props.investment.product_information.display_id}
                      productName={
                        props.investment.product_information.product_name
                      }
                    />
                  </div>
                </Column>
              )}
            </Direction>

            <div className="hide--xs hide--sm" style={{ padding: 0 }}>
              <DataProducts
                title={
                  <div>
                    <div style={{ display: 'inline-block' }}>
                      <Text className="text--light" style={{ color: '#333' }}>
                        {props.investment.product_information.product_name}
                      </Text>
                    </div>
                  </div>
                }
                text={
                  isTermDeposit(
                    props.investment.product_information.product_type
                  ) ? (
                    <TextSmall> Plazo {props.investment.term} días</TextSmall>
                  ) : (
                    <TextSmall>
                      {props.investment.product_information.display_id}{' '}
                    </TextSmall>
                  )
                }
                badge={
                  isTermDeposit(
                    props.investment.product_information.product_type
                  ) && (
                    <TextSmall style={{ paddingTop: '5px' }}>
                      {' '}
                      Vence {props.investment.end_date}
                    </TextSmall>
                  )
                }
                icon={
                  isTermDeposit(
                    props.investment.product_information.product_type
                  ) ? (
                    <IconSavings size={36} />
                  ) : (
                    <IconInvestment size={36} />
                  )
                }
              />
            </div>
          </div>
        )}
        renderCol2={() => (
          <div className="hide--xs hide--sm">
            <DataBalance
              title={
                isTermDeposit(
                  props.investment.product_information.product_type
                ) ? (
                  <TextSmall>Monto invertido</TextSmall>
                ) : (
                  <TextSmall>Saldo a la fecha</TextSmall>
                )
              }
              text={
                <Text className="text--medium" style={{ color: '#333' }}>
                  {isTermDeposit(
                    props.investment.product_information.product_type
                  )
                    ? numberFormatter(
                        props.investment.saved_balance.amount,
                        props.investment.saved_balance.currency_code
                      )
                    : numberFormatter(
                        props.investment.available_balance.amount,
                        props.investment.available_balance.currency_code
                      )}
                </Text>
              }
              observation={
                isTermDeposit(
                  props.investment.product_information.product_type
                ) && (
                  <TextSmall style={{ paddingTop: '5px' }}>
                    {' '}
                    {props.investment.interest_rate}% Interés
                  </TextSmall>
                )
              }
            />
          </div>
        )}
        renderCol3={() => (
          <div className="hide--xs hide--sm">
            {isTermDeposit(
              props.investment.product_information.product_type
            ) && (
              <DataBalance
                title={
                  <div>
                    <div style={{ display: 'inline-block' }}>
                      <TextSmall>Monto a retirar</TextSmall>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        marginRight: '-30px',
                        marginTop: '-10px',
                        paddingLeft: '4px',
                        float: 'right'
                      }}
                    >
                      <SummaryContextMenu
                        productType={
                          props.investment.product_information.product_type
                        }
                        account={
                          props.investment.product_information.display_id
                        }
                        productName={
                          props.investment.product_information.product_name
                        }
                      />
                    </div>
                  </div>
                }
                text={
                  <Text className="text--medium" style={{ color: '#333' }}>
                    {`${numberFormatter(
                      props.investment.available_balance.amount,
                      props.investment.available_balance.currency_code
                    )}`}
                  </Text>
                }
              />
            )}
            {props.investment.product_information.product_type ===
              'mutual_fund' && (
              <div
                style={{
                  display: 'flex',
                  marginRight: '-30px',
                  marginTop: '-10px',
                  paddingLeft: '4px',
                  float: 'right'
                }}
              >
                <SummaryContextMenu
                  productType={
                    props.investment.product_information.product_type
                  }
                  account={props.investment.product_information.display_id}
                  productName={
                    props.investment.product_information.product_name
                  }
                />
              </div>
            )}
          </div>
        )}
        column1={4}
        column2={4}
        column3={4}
      />
    </Margin>
  </Direction>
);
InvestmentContent.prototype = {
  list: PropTypes.object,
  showSald: PropTypes.bool
};

InvestmentContent.defaultProps = {
  list: null,
  showSald: true
};

export default InvestmentContent;
